
const Device = {
    _Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    _BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    _iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    _Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    _Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },

    _isMobile: undefined,
    isMobile: function () {
        if (!navigator) {
            return false;
        }
        if (Device._isMobile === undefined) {
            Device._isMobile = Device._Android() || Device._BlackBerry() || Device._iOS() || Device._Opera() || Device._Windows();
        }
        return Device._isMobile;
    }
}

export default Device;